/* eslint-disable max-classes-per-file */

import { NvbUtskriftVariant } from "../atgarder/atgard-nvb/forms/nvb-utskrift-dialog/nvb-utskrift-dialog.component";

export class AtgardNaturvardesbedomningDTO {
    id: number;
    alder: boolean;
    bedomningSno: boolean;
    dodVed: boolean;
    dodVedTotalPerHa: number;
    dodVedTrslPerHa: number;
    dodVedKvalitet: boolean;
    dodVedKvalitetTotalPerHa: number;
    dodVedKvalitetTrslPerHa: number;
    naturvardesbedomningUtford: boolean;
    naturvardesomrade: NaturvardesomradeDTO;
    hansynskravandeBiotop: boolean;
    hansynMiljovarden: string;
    kandForekomstNaturvardesarter: boolean;
    kandForekomstFornKulturlamn: boolean;
    kompletterandeInformation: string;
    kontinuitet: boolean;
    naturvardestrad: boolean;
    naturvardestradTotalPerHa: number;
    naturvardestradTrslPerHa: number;
    naturvardestradKvalitet: boolean;
    naturvardestradKvalitetTotalPerHa: number;
    nvbKravsEj: boolean;
    skogVardefullFriluftsklivRekreation: boolean;
    tradslag: boolean;
    utfordAv: string | null;
    utfordDatum: string | null;
    viktigForRennaring: boolean;
    atgardGuid: string;
    edited: boolean;
    naturvardesbedomningKalla?: NaturvardesbedomningKalla;
    faltbesokDatum?: string;
    faltbesokKravs?: boolean;
    leverantorKontrolleratAvverkning?: boolean;
    leverantorKontrolleratLaguppfyllnad?: boolean;
    leverantorAccepterarPolicy?: boolean;

    constructor() {
        this.id = undefined;
        this.alder = undefined;
        this.bedomningSno = undefined;
        this.dodVed = undefined;
        this.dodVedTotalPerHa = undefined;
        this.dodVedTrslPerHa = undefined;
        this.dodVedKvalitet = undefined;
        this.dodVedKvalitetTotalPerHa = undefined;
        this.dodVedKvalitetTrslPerHa = undefined;
        this.naturvardesbedomningUtford = undefined;
        this.naturvardesomrade = undefined;
        this.hansynskravandeBiotop = undefined;
        this.hansynMiljovarden = undefined;
        this.kandForekomstNaturvardesarter = undefined;
        this.kandForekomstFornKulturlamn = undefined;
        this.kompletterandeInformation = undefined;
        this.kontinuitet = undefined;
        this.naturvardestrad = undefined;
        this.naturvardestradTotalPerHa = undefined;
        this.naturvardestradTrslPerHa = undefined;
        this.naturvardestradKvalitet = undefined;
        this.naturvardestradKvalitetTotalPerHa = undefined;
        this.nvbKravsEj = undefined;
        this.skogVardefullFriluftsklivRekreation = undefined;
        this.tradslag = undefined;
        this.utfordAv = undefined;
        this.utfordDatum = undefined;
        this.viktigForRennaring = undefined;
        this.atgardGuid = undefined;
        this.edited = undefined;
        this.naturvardesbedomningKalla = undefined;
        this.faltbesokDatum = undefined;
        this.faltbesokKravs = undefined;
        this.leverantorAccepterarPolicy = undefined;
        this.leverantorKontrolleratLaguppfyllnad = undefined;
        this.leverantorKontrolleratAvverkning = undefined;
    }
}

export type NaturvardesbedomningKalla =
  | "Fil"
  | "Formulär"
  | "Riskbedömning"
  | "Riskbedömning-Fil";

export class NaturvardesomradeDTO {
    guid: string;
    namn: string;
    formulartyp: string;
}

export interface RiskbedomningDTO {
  utfordAv?: string | null;
  utfordDatum?: string | null;
}

export const NaturvardesomradeGuids = {
    mellerstaSverige: "473eb0bc-7b56-4dd2-9e2a-7084c497278d",
    norraSverige: "c0e623d6-2974-4d34-907b-4fa397f7494c",
    sodraSverige: "7503a78a-4032-44d2-9d4f-4f6c83d8136e"
};

export function getNvbUtskriftVariant(naturvardesbedomning: AtgardNaturvardesbedomningDTO): NvbUtskriftVariant | null {
    if (!naturvardesbedomning) {
        return null;
    }

    if (naturvardesbedomning.naturvardesbedomningKalla === "Riskbedömning") {
        return "riskbedomning";
    }

    if (naturvardesbedomning.naturvardesbedomningKalla !== "Formulär" && naturvardesbedomning.nvbKravsEj !== false) {
        return null;
    }

    switch (naturvardesbedomning.naturvardesomrade?.guid) {
        case NaturvardesomradeGuids.norraSverige:
            return "norra";
        case NaturvardesomradeGuids.mellerstaSverige:
            return "mellersta";
        case NaturvardesomradeGuids.sodraSverige:
            return "sodra";
        default:
            return null;
    }
}

export interface INvbAggregatedStatus {
    total: number;
    missing: number;
}

export interface INvbUtskriftItem {
    naturvardesbedomning: AtgardNaturvardesbedomningDTO;
    title: string;
    variant: NvbUtskriftVariant;
}

export interface INvbVariantConfig {
    aldersgrans: number;
    label: string;
    visaDodVedKvalitetTrsl: boolean;
    visaDodVedTrsl: boolean;
    visaNaturvardestradTrsl: boolean;
}
